import React, { useEffect, useState } from "react";
import AppCtrl from "../../control/AppCtrl";
import useAlert from "../../hook/useAlert";
import useAtgGames from "../../redux/atgGames/atgGamesAction";
import Config from "../../utils/Config";
import EPage from "../../utils/EPage";
import styles from "./index.module.scss";

const index = () => {
  const { gameUrl } = useAtgGames();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);

  const cbLeaveAtgGames = () => {
    AppCtrl.switchPage(EPage.atgLobby);
    const msg = `正在回到ATG遊戲大廳\n請稍候。`;
    showAlert({ title: msg, showConfirmButton: false, timer: 3000 });
  };

  const backToMainPage = () => {
    setIsLoading(true);
    AppCtrl.requestLeaveAtgGames(cbLeaveAtgGames);
  };

  const onClickExit = () => {
    showAlert({
      title: "確定要離開嗎？",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "確定離開",
      cancelButtonText: "繼續遊戲",
      confirmCb: backToMainPage,
    });
  };

  function onChat() {
    const liveChat = Config.liveChat ? Config.liveChat : "";
    const withAPIGame = Config?.withAPIGame ?? false;
    if (liveChat != "" && !withAPIGame) {
      window.open(liveChat);
    }
  }

  useEffect(() => {
    const uiShowTitle = document.getElementById("showTitle");
    const ShowTitle = Config.showTitle ? Config.showTitle : Config.casinoName;
    if (uiShowTitle && ShowTitle != "") {
      uiShowTitle.innerHTML = ShowTitle;
    }
  }, []);

  return (
    <div className={styles.container}>
      {isLoading && (
        <div className={styles.loadingOverlay}>
          <div className={styles.loadingSpinner}>
            <div className={styles.spinner}></div>
            <div className={styles.loadingText}>離開遊戲中...</div>
          </div>
        </div>
      )}
      <div
        className={styles.header}
        style={{ backgroundImage: "url(img/lobbyui/TopBar.png)" }}
      >
        <input
          id="exitButton"
          type="image"
          src="img/lobbyui/exit.png"
          style={{
            margin: "0 1px",
            float: "right",
            width: "35%",
            maxWidth: "50px",
            maxHeight: "50px",
          }}
          onClick={onClickExit}
        ></input>
        <input
          id="chatButton"
          type="image"
          src="img/lobbyui/chat.png"
          style={{
            margin: "0 1px",
            float: "left",
            width: "35%",
            maxWidth: "50px",
            maxHeight: "50px",
          }}
          onClick={onChat}
        ></input>
        <label
          id="showTitle"
          style={{
            paddingLeft: "10px",
            margin: "15px auto",
            float: "center",
            fontSize: "24px",
          }}
        />
      </div>
      <iframe src={gameUrl} className={styles.iframe} />
    </div>
  );
};

export default index;
